
window.axios = require('axios');

window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

window.axios.defaults.headers.common = {
    // 'X-CSRF-TOKEN': $cookies.get("XSRF-TOKEN"),
    // 'X-XSRF-TOKEN': $cookies.get("XSRF-TOKEN"),
    // 'Authorization': 'Bearer ' + $cookies.get("token") || null,
};

axios.defaults.withCredentials = true;


import Vue from 'vue'
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css'
import '@mdi/font/css/materialdesignicons.css'

Vue.use(Vuetify)

const opts = {}

export default new Vuetify(opts)

